// src/components/ui/2-organisms/Awards/Awards.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import SectionHeader from '../../1-molecules/SectionHeader/SectionHeader';
import Icon from '../../1-molecules/Icon/Icon';
import styles from './Awards.module.css';

// Configuration for award categories
const AWARD_CONFIG = {
  'Award Won': {
    icon: 'https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FBoutee%20Icon%20-%20Trophy.png?alt=media&token=7d489a05-e805-4db9-ad94-f95dff5cb621',
    label: 'Winner',
    iconAlt: 'Trophy'
  },
  'Professional Membership': {
    icon: 'https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FBoutee%20Icon%20-%20Wreath.png?alt=media&token=7e7ec0f7-6192-4f5f-bf65-dbbaeefaf3fa',
    label: 'Member',
    iconAlt: 'Membership Wreath'
  },
  'Qualification': {
    icon: 'https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FBoutee%20Icon%20-%20Certificate.png?alt=media&token=ecf88b19-221c-458b-b10a-3d6fb3a3cc84',
    label: 'Qualification',
    iconAlt: 'Certificate'
  },
  'Award Nomination': {
    icon: 'https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FBoutee%20Icon%20-%20Rosette.png?alt=media&token=edbdef68-5ddb-4d88-a7f0-43ef9a6da92c',
    label: 'Nominated',
    iconAlt: 'Nomination Rosette'
  }
};

const Awards = ({ awards = [], jewellerId, sectionTitle = "Awards & Recognition", disableNavigation = false }) => {
  const navigate = useNavigate();

  // Filter out any awards with categories we don't recognize
  const validAwards = awards.filter(award => award.category && AWARD_CONFIG[award.category]);

  // Don't render the section if there are no valid awards
  if (validAwards.length === 0) {
    return null;
  }

  const handleAwardClick = (award, index) => {
    if (disableNavigation) return;
    // Navigate to award details page
    // You can adjust this route based on your app's routing structure
    navigate(`/jeweller/${jewellerId}/award/${index}`, {
      state: { award }
    });
  };

  return (
    <section className={styles.awardsSection}>
      <SectionHeader title={sectionTitle} />
      <ul className={styles.awardsList}>
        {validAwards.map((award, index) => {
          const config = AWARD_CONFIG[award.category];
          
          return (
            <li key={index} className={styles.awardItem}>
              <button
                className={styles.awardButton}
                onClick={() => handleAwardClick(award, index)}
                aria-label={disableNavigation ? `${award.title}` : `View details for ${award.title}`}
                disabled={disableNavigation}
              >
                <div className={styles.awardContent}>
                  <img 
                    src={config.icon} 
                    alt={config.iconAlt}
                    className={styles.awardIcon}
                  />
                  <div className={styles.awardText}>
                    <span className={styles.awardLabel}>{config.label}.</span>
                    <span className={styles.awardTitle}>{award.title}</span>
                  </div>
                </div>
                <Icon 
                  name="chevron-right" 
                  size="s" 
                  className={styles.chevron}
                />
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default Awards;
